import { useState, useEffect } from 'react';

const GeneralSettings = () => {
  const [formData, setFormData] = useState({
    siteName: 'ProKidsApp',
    siteDescription: 'Plataforma para la gestión de Liga Prokids',
    siteUrl: 'https://prokidsapp.com',
    logoUrl: '/logo.png',
    faviconUrl: '/favicon.ico',
    primaryColor: '#1976d2',
    secondaryColor: '#ff9800',
    language: 'es',
    timezone: 'Europe/Madrid',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    defaultCurrency: 'EUR',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // En una implementación real, obtendríamos estos datos de la API
    // Por ahora, usamos los datos de ejemplo definidos en el estado inicial
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(null);

    try {
      // En una implementación real, enviaríamos estos datos a la API
      console.log('Datos del formulario:', formData);

      // Simulamos una respuesta exitosa
      setTimeout(() => {
        setSuccess(true);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error('Error saving settings:', error);
      setError('Error al guardar la configuración');
      setLoading(false);
    }
  };

  if (loading && Object.keys(formData).length === 0) {
    return <div className="loading">Cargando configuración...</div>;
  }

  return (
    <div className="settings-section">
      <h2>Configuración General</h2>
      <p className="settings-description">Configura los ajustes generales de la plataforma.</p>

      {success && <div className="alert alert-success">Configuración guardada correctamente.</div>}

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="settings-card">
          <h3>Información del Sitio</h3>
          <div className="form-group">
            <label htmlFor="siteName">Nombre del Sitio</label>
            <input
              type="text"
              id="siteName"
              name="siteName"
              value={formData.siteName}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="siteDescription">Descripción del Sitio</label>
            <textarea
              id="siteDescription"
              name="siteDescription"
              value={formData.siteDescription}
              onChange={handleInputChange}
              className="form-control"
              rows="3"
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="siteUrl">URL del Sitio</label>
            <input
              type="url"
              id="siteUrl"
              name="siteUrl"
              value={formData.siteUrl}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>
        </div>

        <div className="settings-card">
          <h3>Apariencia</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="logoUrl">URL del Logo</label>
              <input
                type="text"
                id="logoUrl"
                name="logoUrl"
                value={formData.logoUrl}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="faviconUrl">URL del Favicon</label>
              <input
                type="text"
                id="faviconUrl"
                name="faviconUrl"
                value={formData.faviconUrl}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="primaryColor">Color Primario</label>
              <div className="color-input-group">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  value={formData.primaryColor}
                  onChange={handleInputChange}
                  className="form-control color-picker"
                />
                <input
                  type="text"
                  value={formData.primaryColor}
                  onChange={handleInputChange}
                  name="primaryColor"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="secondaryColor">Color Secundario</label>
              <div className="color-input-group">
                <input
                  type="color"
                  id="secondaryColor"
                  name="secondaryColor"
                  value={formData.secondaryColor}
                  onChange={handleInputChange}
                  className="form-control color-picker"
                />
                <input
                  type="text"
                  value={formData.secondaryColor}
                  onChange={handleInputChange}
                  name="secondaryColor"
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="settings-card">
          <h3>Localización</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="language">Idioma</label>
              <select
                id="language"
                name="language"
                value={formData.language}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="es">Español</option>
                <option value="en">English</option>
                <option value="fr">Français</option>
                <option value="de">Deutsch</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="timezone">Zona Horaria</label>
              <select
                id="timezone"
                name="timezone"
                value={formData.timezone}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="Europe/Madrid">Europe/Madrid</option>
                <option value="Europe/London">Europe/London</option>
                <option value="America/New_York">America/New_York</option>
                <option value="America/Los_Angeles">America/Los_Angeles</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="dateFormat">Formato de Fecha</label>
              <select
                id="dateFormat"
                name="dateFormat"
                value={formData.dateFormat}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="timeFormat">Formato de Hora</label>
              <select
                id="timeFormat"
                name="timeFormat"
                value={formData.timeFormat}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="24h">24h</option>
                <option value="12h">12h (AM/PM)</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="defaultCurrency">Moneda Predeterminada</label>
              <select
                id="defaultCurrency"
                name="defaultCurrency"
                value={formData.defaultCurrency}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="EUR">Euro (€)</option>
                <option value="USD">US Dollar ($)</option>
                <option value="GBP">British Pound (£)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GeneralSettings;
